<script context="module" lang="ts">
  export enum DecisionModalType {
    approve = "approve",
    decline = "decline",
  }
</script>

<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";

  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import Flash from "@shared/services/flashv2.js";

  import ProductApprovalStore from "@shared/svelte/Stores/ProductApprovalStore";

  import type { LimitedOrderingProduct } from "@shared/types/LimitedOrderingProduct";
  import { ProductApprovalsIndividualActionSendRequestEntity } from "@shared/services/event_tracking/entities";

  const { trackClick } = EventTracking;

  export let request: LimitedOrderingProduct;
  export let show: boolean;
  export let onClose;
  export let modalType: DecisionModalType;

  const modalTypeMap = {
    approve: {
      title: "Approve requested product",
      button: "Approve",
      action: "approve",
      message: "Product approved! It will show up in ordering lists right away.",
    },

    decline: {
      title: "Decline requested product",
      button: "Decline",
      action: "decline",
      message: "Product declined!",
    },
  };

  const removeFromStore = () => {
    ProductApprovalStore.update(store => {
      store.productRequests = store.productRequests.filter(product => product.id !== request.id);
      return store;
    });
  };

  const onSave = async () => {
    try {
      await HttpPromise({
        method: "PUT",
        url: "/api/retailer/limited_ordering_product_requests/" + request.id,
        data: {
          approval_note: request.approval_note,
          request_status: modalType === "approve" ? "approved" : "denied",
        },
      });
      Flash.now({
        message: modalTypeMap[modalType].message,
        type: "success",
      });

      trackClick(
        "product_approvals_individual_send_request",
        new ProductApprovalsIndividualActionSendRequestEntity({
          limited_ordering_request_id: request.id,
          product_id: request.product.id,
          product_line_id: request.product.product_line.id,
          action: modalType,
        }),
      );

      removeFromStore();
      onClose();
    } catch (res) {
      Flash.now({ message: "Error saving approval status", type: "error" });
    }
  };
</script>

<div class="fizz-styles">
  <Modal closeOnBackgroundClick={false} fizzModal={true} medium={true} bind:show centeredModal>
    <div class="layout-header-footer">
      <header class="fizz-modal-header">
        <p class="fizz-text-large fizz-text-strong">{modalTypeMap[modalType].title}</p>
        <button type="button" class="fizz-modal-toggle fizz-modal-close" on:click={onClose}>
          <Icon type="X" height={14} width={14} />
        </button>
      </header>
      <section class="fizz-modal-main fizz-text-medium fizz-flow-16" data-grid-area="main">
        <p>
          Are you sure you want to {modalTypeMap[modalType].action}
          <span class="fizz-text-strong">{request.product.name}</span>?
        </p>
        <div>
          <label for="approval_note" class="fizz-label fizz-stack-4">Add a note</label>
          <textarea
            class="fizz-input-text fizz-full-width"
            bind:value={request.approval_note}
            name="approval_note"
            id="approval_note"
          ></textarea>
        </div>
      </section>
      <footer class="fizz-modal-footer fizz-flex-row fizz-justify-end">
        <button type="button" class="fizz-button fizz-modal-toggle" on:click={onClose}>
          Cancel
        </button>
        <button type="button" class="fizz-button-secondary fizz-modal-toggle" on:click={onSave}>
          {modalTypeMap[modalType].button}
        </button>
      </footer>
    </div>
  </Modal>
</div>
